import { render, staticRenderFns } from "./view-product.vue?vue&type=template&id=1a4d5186&scoped=true"
import script from "./view-product.vue?vue&type=script&lang=js"
export * from "./view-product.vue?vue&type=script&lang=js"
import style0 from "./view-product.vue?vue&type=style&index=0&id=1a4d5186&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d5186",
  null
  
)

export default component.exports